import React from "react";
import Header from "./Header";
import Footer from "./Footer";

/**
 * Layout for legal pages (Impressum, Datenschutz, Cookies).
 * Renders Header, main content area with consistent padding, and Footer.
 */
const LegalPageLayout = ({ title, children }) => {
  return (
    <div className="min-h-screen bg-[var(--vortex-bg)] w-full overflow-x-hidden">
      <Header />
      <main id="main-content" className="w-full overflow-x-hidden">
        <article className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16 md:py-20 pb-24 w-full min-w-0">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[var(--vortex-text-primary)] mb-6 sm:mb-8">
            {title}
          </h1>
          <div className="prose legal-content text-[var(--vortex-text-secondary)] space-y-6 text-base leading-relaxed">
            {children}
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPageLayout;
